import { Box } from '@mui/material';
import classNames from 'classnames';
import React, { FC, ForwardedRef, forwardRef, InputHTMLAttributes, useEffect, useRef } from 'react';
import { Loader } from 'shared/components/Loader';
import { useStyles } from './SearchInput.styles';

type SearchInputProps = {
  value?: string;
  focusOnInit?: boolean;
  loading?: boolean;
} & InputHTMLAttributes<HTMLInputElement>;

export const SearchInput: FC<SearchInputProps> = forwardRef(
  (
    { value, focusOnInit = false, className, loading, ...props },
    ref: ForwardedRef<HTMLInputElement | null>
  ) => {
    const { classes } = useStyles();

    const inputRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
      if (focusOnInit) {
        inputRef?.current?.focus();
      }
    }, [focusOnInit, inputRef]);

    return (
      <Box className={classNames(className, classes.root)}>
        <input
          type="text"
          className="form-control search"
          value={value}
          ref={focusOnInit ? inputRef : ref}
          {...props}
        />
        {loading && (
          <Box className={classes.loader}>
            <Loader size={24} />
          </Box>
        )}
      </Box>
    );
  }
);
